<div id="layout-wrapper">
	<!-- Top Bar -->
	<app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
	<!-- Side Bar -->
	<app-sidebar></app-sidebar>
	<div class="main-content">
		<div class="page-content">
			<div class="container-fluid">
				<!-- Main Content -->
				<router-outlet></router-outlet>
			</div>
		</div>
		<!-- Footer -->
	</div>
</div>
<!-- Right Side Bar -->
<!-- <app-rightsidebar  (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar> -->
<!--chat extension-->
<!-- <app-chat-extension></app-chat-extension> -->
<!-- Vera AI Assistant -->
<app-vera-chatbot></app-vera-chatbot>

